// 全局的 store  后续有时间全部整理推荐方式
import { ref } from 'vue'
import { defineStore } from 'pinia';
import {log} from "app-lib-log";
// let {screenHeight} = uni.getSystemInfoSync();
const screenHeight = 726;
// app sub 固定高度 不然滚动会失效

export const useGlobalStore = defineStore('global', () => {
  const global = ref({
      scollTop:0,
      systemInfo:{
        viewHeight:screenHeight // 暂时是屏幕的高度
      }
  })

  window.global = global.value; // 兼容旧的写法
  // 支持动态扩展 key 值
  const setGlobal = (key, value) => {
    log.mi("setGlobal",key, value)
    let kes = key.split(".");
    if(kes.length>1){
      debugger;
      let current = global.value;
      for(let i=0;i<kes.length-1;i++){

        if(current[kes[i]]===void 0){ // 不存在则创建
          current[kes[i]]={};
        }
        current= current[kes[i]];
      }
      current[kes[kes.length-1]] = value
    }else{
      global.value[key] = value
    }
  }
  return { global, setGlobal }
})
